import { render, staticRenderFns } from "./PhoenixFooter.vue?vue&type=template&id=8d74ccdc"
import script from "./PhoenixFooter.vue?vue&type=script&lang=js"
export * from "./PhoenixFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports